const PageHeader = ({ title, subtitle }) => (
  <div className="mb-6">
    <h1 className="text-lg font-semibold text-text-primary">{title}</h1>
    {subtitle && <p className="text-xs text-text-muted mt-0.5">{subtitle}</p>}
  </div>
);

export default PageHeader;
